// extracted by mini-css-extract-plugin
export default {"alert":"AlertTemplate_alert__07Rvg","containerMsg":"AlertTemplate_containerMsg__Bz-Uk","icon":"AlertTemplate_icon__Hngis"};